import React from "react";
import { contactMethods } from "../utills/CommonData";
import { Link } from "react-router-dom";

const CallToAction = () => {
  return (
    <div className="flex flex-col gap-5">
      <div className="bg-error p-2 rounded  mx-auto">
        <h1 className="font-bold md:text-lg text-base text-center">
          Let’s connect and power up your experience!
        </h1>
      </div>
      {contactMethods.map((method, index) => (
        <div
          key={index}
          className="shadow-md bg-white text-black rounded-lg flex flex-row md:p-5 p-3 gap-4 items-center"
        >
          <p className={`rounded-full shadow-md p-3 text-darkGray`}>
            {method.icon}
          </p>
          <div>
            <p className="mb-4 text-darkGray text-lg">{method.text}</p>
            <button
              className={`text-white p-2 rounded-full w-32 shadow bg-error`}
            >
              <Link to={method.to}>{method.buttonText}</Link>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CallToAction;
